import './condition';

// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { repeat } from 'lit/directives/repeat.js';

// Import style for web component
import styles from './web-component-style.scss?inline';

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-log-loop-filters' )
export class AutomatorLogItemLoopFilters extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// Properties
	// The loop filters of this loop block
	@property( { type: Array, attribute: false } ) accessor loopFilters;

	// The ID of the current item opened
	@property( { type: String, attribute: 'sidebar-source-id' } ) accessor sidebarSourceID;

	// This property is used to indicate to the web component that it shouldn't try to retrieve data from the server
	// and that it should use the data provided when it was created
	@property( { type: Boolean, attribute: 'import-mode' } ) accessor isImportMode = false;

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<div class="conditions">
				${ repeat(
					this.loopFilters,
					condition => condition.id,
					condition => html`
						<uap-log-loop-filter-condition
							condition-id=${ condition.id }
							condition-code=${ condition.code }

							integration-code=${ condition.integration_code }

							?is-open=${ this.sidebarSourceID === `loop-condition-${ condition.id }` }

							?import-mode=${ this.isImportMode }

							.titleHTML=${ condition.title_html }
							.fields=${ condition.fields }
						></uap-log-loop-filter-condition>
					`
				) }
			</div>
		`;
	}
}